import type { VoiceSignatureCopyKey } from '@/i18n/ns/voice-signature';
import { voiceErrorCopy } from './error-copy';

/** Only declared server error codes select copy; never render raw API messages. */
export function signatureError(
  error: unknown,
  copy: Record<VoiceSignatureCopyKey, string>,
): string {
  const code =
    error && typeof error === 'object' && 'code' in error && typeof error.code === 'string'
      ? error.code
      : error instanceof Error
        ? error.message
        : '';
  const ref = voiceErrorCopy('voice-signature', code);
  return ref?.ns === 'voice-signature' ? copy[ref.key] : copy.unavailable;
}
